import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=977edaa6&scoped=true"
import script from "./echart.vue?vue&type=script&lang=js"
export * from "./echart.vue?vue&type=script&lang=js"
import style0 from "./echart.vue?vue&type=style&index=0&id=977edaa6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977edaa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Workplace\\vueProject\\edu_aim\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('977edaa6')) {
      api.createRecord('977edaa6', component.options)
    } else {
      api.reload('977edaa6', component.options)
    }
    module.hot.accept("./echart.vue?vue&type=template&id=977edaa6&scoped=true", function () {
      api.rerender('977edaa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/hwk/echart.vue"
export default component.exports